/* eslint-disable arrow-parens */
/* eslint-disable radix */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Row,
  Spin,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';

import { CheckCircleOutlined } from '@ant-design/icons';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  deleteRiesgoDeTrabajo,
  getRiesgosDeTrabajo,
  patchRiesgoDeTrabajo,
  postRiesgoDeTrabajo,
} from 'api/catalogos/RiesgoDeTrabajo';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import { NOMBRES_PATTERN } from 'utils/patterns';

export const RiesgoDeTrabajoPermission = {
  permissionModel: 'riesgodetrabajo',
};

const RiesgoDeTrabajo = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [periodoFiscal, setPeriodoFiscal] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  // funcion para validar si el año seleccionado ya existe en la tabla
  const [añoDuplicado, setAñoDuplicado] = useState(false);
  const añoSeleccionado = Form.useWatch('periodo_fiscal', form);
  useEffect(() => {
    if (!añoSeleccionado || selectedRowKeys.length > 0) {
      setAñoDuplicado(false);
      return;
    }

    const existe = data.some((item) => item.periodo_fiscal === añoSeleccionado);
    setAñoDuplicado(existe);
  }, [añoSeleccionado, data, selectedRowKeys]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRiesgosDeTrabajo();
    setData(formatReceived(_data));
    setLoading(false);
  };

  // funcion para validar si el año de la vigencia final es el posterior a la vigencia inicial
  const [vigenciaFinalInvalida, setVigenciaFinalInvalida] = useState(false);
  const [vigenciaInicialInvalida, setVigenciaInicialInvalida] = useState(false);

  const vigenciaInicial = Form.useWatch('vigencia_inicial', form);
  const vigenciaFinal = Form.useWatch('vigencia_final', form);

  useEffect(() => {
    if (!vigenciaInicial || !vigenciaFinal) {
      setVigenciaFinalInvalida(false);
      return;
    }

    const fechaInicial = new Date(vigenciaInicial);
    const fechaFinal = new Date(vigenciaFinal);

    const añoInicial = fechaInicial.getFullYear();
    const añoFinal = fechaFinal.getFullYear();

    // ✅ validación correcta:
    const esValida = (
      fechaFinal.getTime() > fechaInicial.getTime() && añoFinal === añoInicial + 1
    );

    setVigenciaFinalInvalida(!esValida);
  }, [vigenciaInicial, vigenciaFinal]);

  useEffect(() => {
    if (!vigenciaInicial || !añoSeleccionado) {
      setVigenciaInicialInvalida(false);
      return;
    }

    const periodo = periodoFiscal.find((p) => p.id === añoSeleccionado);
    if (!periodo) {
      setVigenciaInicialInvalida(false);
      return;
    }

    const añoPeriodo = parseInt(periodo.periodo);
    const añoVigencia = new Date(vigenciaInicial).getFullYear();

    setVigenciaInicialInvalida(añoVigencia !== añoPeriodo);
  }, [vigenciaInicial, añoSeleccionado, periodoFiscal]);

  // useEffect(() => {
  //   if (vigenciaFinal) {
  //     form.setFieldValue('estados_globales', ESTATUS_INACTIVO);
  //   }
  //   if (!vigenciaFinal) {
  //     form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
  //   }
  // }, [vigenciaFinal]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
        _periodos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getRiesgosDeTrabajo(),
        getPeriodosFiscales(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setPeriodoFiscal(_periodos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    fetchData();
  };

  const onClickEdit = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    if (!([1].includes(key))) {
      const match = data?.find((item) => item.id === key);
      setTimeout(() => {
        if (match) {
          form.resetFields();
          setTimeout(() => {
            form.setFieldsValue(formatReceived(match));
            setDisableFields(match?.estados_globales !== ESTATUS_ACTIVO);
            setVisible(true);
          });
        }
      });
    } else {
      message.warn('Este registro no es editable');
    }
    setLoading(false);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una baja ya autorizada');
        return;
      }

      const formatDate = (date) => {
        if (!date) return null;
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DD');
        }
        return new Date(date).toISOString().split('T')[0];
      };

      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };

      // Limpiar fechas
      vals.vigencia_inicial = formatDate(vals.vigencia_inicial);
      vals.vigencia_final = formatDate(vals.vigencia_final);

      const res = await patchRiesgoDeTrabajo(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      values.prima_de_riesgo = parseFloat(values.prima_de_riesgo).toFixed(5);

      // Formatear fechas si vienen en formato moment
      if (values.vigencia_inicial?.format) {
        values.vigencia_inicial = values.vigencia_inicial.format('YYYY-MM-DD');
      }
      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }

      const saved = await (key
        ? patchRiesgoDeTrabajo(key, values)
        : postRiesgoDeTrabajo(values));

      if (saved) {
        onCancel();
        await fetchData();
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteRiesgoDeTrabajo(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    setSelectedRowKeys([]);
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Año',
      dataIndex: 'periodo_fiscal',
      key: 'periodo_fiscal',
      width: 400,
      render: (val) => periodoFiscal.find((e) => e.id === val)?.periodo,
    },
    {
      titleText: 'Prima de Riesgo',
      dataIndex: 'prima_de_riesgo',
      key: 'prima_de_riesgo',
      width: 400,
      render: (val) => (val ? Number(val).toFixed(5) : '0.00000'),
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'vigencia_inicial',
      key: 'vigencia_inicial',
      width: 400,
      render: (val) => (val ? val?.format(DATE_FRONTEND_FORMAT) : 'N/A'),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 400,
      render: (val) => (val ? val?.format(DATE_FRONTEND_FORMAT) : 'N/A'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'riesgodetrabajo', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Riesgo de Trabajo`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              // allowSave={!disableFields}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Col spam={24}>
              <Form.Item
                name="periodo_fiscal"
                label="Año"
                hasFeedback
                validateStatus={añoDuplicado ? 'error' : undefined}
                help={añoDuplicado ? 'Ya existe un registro para este año' : undefined}
                rules={[
                  {
                    required: true,
                    message: 'El campo es requerido',
                  },
                ]}
              >
                {/* <Input
                  type="number"
                  onKeyDown={(e) => {
                    if (['e', '+', '-'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                /> */}
                <Select
                  labelProp="periodo"
                  dataSource={periodoFiscal}
                />
              </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="prima_de_riesgo"
                label="Prima de Riesgo"
                rules={rules.required}
              >
                <InputNumber
                  min={0}
                  step={0.00001}
                  precision={5}
                  stringMode
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="vigencia_inicial"
                label="Vigencia Inicial"
                rules={rules.required}
                validateStatus={vigenciaInicialInvalida ? 'error' : undefined}
                help={vigenciaInicialInvalida ? 'El año debe coincidir con el periodo fiscal seleccionado' : undefined}
                hasFeedback
              >
                <DatePicker
                  format={DATE_FRONTEND_FORMAT}
                  disabled={selectedRowKeys.length !== 0}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="vigencia_final"
                label="Vigencia Final"
                hasFeedback
                validateStatus={vigenciaFinalInvalida ? 'error' : undefined}
                help={vigenciaFinalInvalida ? 'El año de debe ser uno posterior al de la Vigencia Inicial' : undefined}
              >
                <DatePicker
                  format={DATE_FRONTEND_FORMAT}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled={selectedRowKeys.length <= 0 || disableFields}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El registro seleccionado"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar es Motivos de Baja ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default RiesgoDeTrabajo;
